import { useState } from "react";
import Modal from "../../common/modals";
import { useReportUserMutation } from "../../../store/api/userApi";
import { toastError, toastSuccess } from "../../toast";
import { Cross } from "../../../icons";
import { useAppDispatch, useAppSelector } from "../../../hooks/store-hooks";
import { closeModal } from "../../../store/slices/modalSlice";

const ReportUser = () => {
  const dispatch = useAppDispatch();
  const [reportType, setreportType] = useState("");
  const [reportUser, { isLoading }] = useReportUserMutation();
  const { modalData: userId } = useAppSelector((state) => state.modal || {});

  const handleReport = async () => {
    try {
      const reportResponse = await reportUser({
        data: {
          user_id: userId,
          report_type: reportType,
        },
      });
      toastSuccess({ message: reportResponse?.data?.message });
    } catch (error: any) {
      toastError({ message: error?.data?.error?.message });
    }
    dispatch(closeModal());
  };

  return (
    <Modal isOpen size="large">
      <div className="flex flex-col gap-6 p-6">
        <div className="flex justify-between w-full">
          <div className="text-primary-900 text-2.8xl font-bold font-['SF Pro'] leading-8 tracking-tight">
            Report this user
          </div>
          <button
            type="button"
            onClick={() => {
              dispatch(closeModal());
            }}
          >
            <Cross />
          </button>
        </div>
        <div className="text-primary-900 text-xl font-['SF Pro'] font-semibold leading-6">
          Select a reason that applies
        </div>
        <form
          className="flex flex-col gap-5 pb-5 border-b"
          id="report-form"
          onSubmit={(e: any) => {
            e.preventDefault();
            handleReport();
          }}
        >
          <div className="flex items-center justify-between w-full">
            <div className="flex flex-col">
              <div className=" text-neutral-700 text-base font-semibold font-['SF Pro'] leading-snug">
                {"Misleading or false information"}
              </div>
              <div className=" text-neutral-700 text-sm font-normal font-['SF Pro'] leading-4">
                User shares incorrect or intentionally deceptive information
              </div>
            </div>
            <input
              onChange={(e) => {
                setreportType(e.target.value);
              }}
              type="radio"
              name="report"
              value="misleading"
              className="w-5"
            ></input>
          </div>

          <div className="flex items-center justify-between w-full">
            <div className="flex flex-col">
              <div className=" text-neutral-700 text-base font-semibold font-['SF Pro'] leading-snug">
                {"Fraud or scam"}
              </div>
              <div className=" text-neutral-700 text-sm font-normal font-['SF Pro'] leading-4">
                User is pretending to be someone else or misleading others
                (e.g., phishing, scamming)
              </div>
            </div>
            <input
              onChange={(e) => {
                setreportType(e.target.value);
              }}
              type="radio"
              name="report"
              value="scam"
              className="w-5"
            ></input>
          </div>
          <div className="flex items-center justify-between w-full">
            <div className="flex flex-col">
              <div className=" text-neutral-700 text-base font-semibold font-['SF Pro'] leading-snug">
                {"Hate speech"}
              </div>
              <div className=" text-neutral-700 text-sm font-normal font-['SF Pro'] leading-4">
                User posts offensive or harmful content based on an individual
                or group’s identity
              </div>
            </div>
            <input
              onChange={(e) => {
                setreportType(e.target.value);
              }}
              type="radio"
              name="report"
              value="hate"
              className="w-5"
            ></input>
          </div>
          <div className="flex items-center justify-between w-full">
            <div className="flex flex-col">
              <div className=" text-neutral-700 text-base font-semibold font-['SF Pro'] leading-snug">
                {"Illegal goods or service"}
              </div>
              <div className=" text-neutral-700 text-sm font-normal font-['SF Pro'] leading-4">
                User references or promotes items or activities that violate
                financial or legal regulations
              </div>
            </div>
            <input
              onChange={(e) => {
                setreportType(e.target.value);
              }}
              type="radio"
              name="report"
              value="illegal"
              className="w-5"
            ></input>
          </div>
          <div className="flex items-center justify-between w-full">
            <div className="flex flex-col">
              <div className=" text-neutral-700 text-base font-semibold font-['SF Pro'] leading-snug">
                {"Personal information"}
              </div>
              <div className=" text-neutral-700 text-sm font-normal font-['SF Pro'] leading-4">
                User shares private or personally identifying information
                without consent
              </div>
            </div>
            <input
              onChange={(e) => {
                setreportType(e.target.value);
              }}
              type="radio"
              name="report"
              value="sensitive"
              className="w-5"
            ></input>
          </div>
          <div className="flex items-center justify-between w-full">
            <div className="flex flex-col">
              <div className=" text-neutral-700 text-base font-semibold font-['SF Pro'] leading-snug">
                {"Harassment or Bullying"}
              </div>
              <div className=" text-neutral-700 text-sm font-normal font-['SF Pro'] leading-4">
                User engages in targeted harassment, threats, or bullying.
              </div>
            </div>
            <input
              onChange={(e) => {
                setreportType(e.target.value);
              }}
              type="radio"
              name="report"
              value="harassment"
              className="w-5"
            ></input>
          </div>
          <div className="flex items-center justify-between w-full">
            <div className="flex flex-col">
              <div className=" text-neutral-700 text-base font-semibold font-['SF Pro'] leading-snug">
                {"Spam or Advertising"}
              </div>
              <div className=" text-neutral-700 text-sm font-normal font-['SF Pro'] leading-4">
                User posts repetitive or unwanted content, unsolicited
                promotions, or other disruptive spam that violates community
                guidelines.
              </div>
            </div>
            <input
              onChange={(e) => {
                setreportType(e.target.value);
              }}
              type="radio"
              name="report"
              value="spam"
              className="w-5"
            ></input>
          </div>
          <div className="flex items-center justify-between w-full">
            <div className="flex flex-col">
              <div className=" text-neutral-700 text-base font-semibold font-['SF Pro'] leading-snug">
                {"Other"}
              </div>
              <div className=" text-neutral-700 text-sm font-normal font-['SF Pro'] leading-4">
                Category for issues that don't fit neatly into the above.
              </div>
            </div>
            <input
              onChange={(e) => {
                setreportType(e.target.value);
              }}
              type="radio"
              name="report"
              value="other"
              className="w-5"
            ></input>
          </div>
        </form>
        <div className="flex justify-end w-full">
          <button
            className="py-1 px-2.5 font-semibold disabled:bg-opacity-50 disabled:cursor-not-allowed rounded-[40px] text-white leading-snug text-base bg-secondary-300"
            disabled={isLoading || !reportType}
            form="report-form"
          >
            Submit Report
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ReportUser;
